import { RiskRegisterEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const create = async (data: any): Promise<any> =>
  APIManager.sendPost(RiskRegisterEnds.CREATE, data, true, {}, {}, axios);

const getAll = async (queryString: string): Promise<any> =>
  APIManager.sendGet(
    RiskRegisterEnds.GET_ALL(queryString),
    true,
    {},
    {},
    axios
  );

const update = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(RiskRegisterEnds.UPDATE(id), data, true, {}, {}, axios);

const detail = async (id: string): Promise<any> =>
  APIManager.sendGet(RiskRegisterEnds.DETAIL(id), true, {}, {}, axios);

const linkAISystem = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(
    RiskRegisterEnds.LINK_AI_SYSTEM(id),
    data,
    true,
    {},
    {},
    axios
  );

const linkDataset = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(
    RiskRegisterEnds.LINK_DATASET(id),
    data,
    true,
    {},
    {},
    axios
  );

const deleteRisk = async (id: string): Promise<any> =>
  APIManager.sendDelete(RiskRegisterEnds.DELETE(id), true, {}, {}, axios);

export const RiskRegisterService = {
  create,
  getAll,
  update,
  detail,
  linkAISystem,
  linkDataset,
  deleteRisk,
};
